export default {
  state: {
    data: false,
  },
  getters: {
    //
  },
  actions: {
    removeStudents(context) {
      context.commit("updateStudent", false)
    },
  },
  mutations: {
    updateStudent(state, data) {
      return state.data = data
    }
  }
}